'use client'

import Image from 'next/image'
import { useEffect } from 'react'

export default function FutureDirectionSection() {
  useEffect(() => {
    // Initialize slider
    const initSlider = () => {
      if (
        typeof window.jQuery === 'function' &&
        typeof window.jQuery.fn.slick === 'function'
      ) {
        const $slider = window.$('#bg-slider')
        if ($slider.length && !$slider.hasClass('slick-initialized')) {
          $slider.slick({
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 1000,
            arrows: false,
            swipe: true,
            slidesToShow: 1,
            cssEase: 'linear',
            pauseOnFocus: true,
            pauseOnHover: true,
            dots: true,
            dotsClass: 'pagination-dots',
            infinite: true,
          })
        }
      }
    }

    // Try to initialize immediately
    initSlider()

    // If not ready, set up an interval to check
    const checkInterval = setInterval(() => {
      if (
        typeof window.jQuery === 'function' &&
        typeof window.jQuery.fn.slick === 'function'
      ) {
        initSlider()
        clearInterval(checkInterval)
      }
    }, 100)

    // Clean up interval after 5 seconds if libraries haven't loaded
    const timeoutId = setTimeout(() => clearInterval(checkInterval), 5000)

    return () => {
      clearInterval(checkInterval)
      clearTimeout(timeoutId)
      // Cleanup slider on unmount
      const $slider = window.$('#bg-slider')
      if ($slider.length && $slider.hasClass('slick-initialized')) {
        $slider.slick('unslick')
      }
    }
  }, [])

  return (
    <section className='mx-auto grid grid-cols-12 gap-5 px-4 py-10 md:px-16 md:py-20'>
      <div className='text-heading-6 md:text-heading-2 col-span-12 text-center leading-none md:mb-4 md:px-16'>
        Định hướng tương lai
      </div>
      <div
        className='col-span-12'
        id='bg-slider'
        style={{
          backgroundImage:
            "url('https://mcdn.coolmate.me/image/March2025/mceclip4_139.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          padding: '80px',
          borderRadius: '16px',
        }}
      >
        {/* First Slide - Innovation */}
        <div className='outline-none'>
          <div className='grid grid-cols-12 gap-5'>
            <div className='col-span-12 md:col-span-5 md:flex md:flex-col md:justify-between'>
              <div className='text-heading-6 md:text-heading-4 2xl:text-heading-2 leading-tight text-white'>
                Đổi mới sáng tạo Innovation
              </div>
              <div className='mt-6 text-base text-white md:mt-10 md:text-2xl'>
                <div>
                  Coolmate cam kết sẽ đầu tư cho hoạt động nghiên cứu đổi mới,
                  và sáng tạo trong làm sản phẩm với ngân sách tối thiểu là 1%
                  doanh thu.
                </div>
                <div className='mt-2 md:mt-6'>
                  Việc đổi mới, sáng tạo sẽ tập trung vào:{' '}
                  <span className='font-semibold'>
                    Tăng công năng của sản phẩm, tăng chất lượng và độ hoàn
                    thiện của sản phẩm, tối ưu trong sản xuất để mang lại giá cả
                    tốt hơn.
                  </span>
                </div>
              </div>
            </div>
            <div className='col-span-12 md:col-span-7 2xl:col-span-8'>
              <Image
                src='https://mcdn.coolmate.me/image/March2025/mceclip3_33.png'
                alt='Future Direction'
                width={1000}
                height={1000}
                className='w-full object-cover'
              />
            </div>
          </div>
        </div>

        {/* Second Slide - Customer Base Expansion */}
        <div className='outline-none'>
          <div className='grid grid-cols-12 gap-5'>
            <div className='col-span-12 md:flex md:flex-col md:justify-between'>
              <div className='col-span-12 md:flex md:items-center md:justify-between'>
                <div className='text-heading-6 md:text-heading-4 2xl:text-heading-2 leading-tight text-white'>
                  Mở rộng tệp <br className='md:hidden' /> khách hàng
                </div>
                <div className='hidden items-center gap-3 md:flex'>
                  <div className='rounded-2xl bg-white px-6 py-3 text-2xl font-medium text-black'>
                    Men only
                  </div>
                  <div>
                    <svg
                      width='29'
                      height='13'
                      viewBox='0 0 29 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M29 6.25L18.8985 0.655963L19.1047 12.2011L29 6.25ZM1.01785 7.74984L20.0193 7.41053L19.9836 5.41085L0.982146 5.75016L1.01785 7.74984Z'
                        fill='white'
                      />
                    </svg>
                  </div>
                  <div className='rounded-2xl bg-white px-6 py-3 text-2xl font-medium text-black'>
                    Men | Women | Kids
                  </div>
                </div>
              </div>
              <div className='col-span-12 mt-4 grid grid-cols-1 gap-5 md:mt-10 md:grid-cols-3 md:items-end'>
                <picture className='w-full'>
                  <source
                    srcSet='https://mcdn.coolmate.me/image/March2025/mceclip11_63.png'
                    media='(max-width: 768px)'
                  />
                  <Image
                    src='https://mcdn.coolmate.me/image/March2025/mceclip8_27.png'
                    alt='Customer Base Expansion'
                    width={1000}
                    height={1000}
                    className='w-full'
                  />
                </picture>
                <picture className='w-full'>
                  <source
                    srcSet='https://mcdn.coolmate.me/image/March2025/mceclip9_22.png'
                    media='(max-width: 768px)'
                  />
                  <Image
                    src='https://mcdn.coolmate.me/image/March2025/mceclip6_16.png'
                    alt='Customer Base Expansion'
                    width={1000}
                    height={1000}
                    className='w-full'
                  />
                </picture>
                <picture className='w-full'>
                  <source
                    srcSet='https://mcdn.coolmate.me/image/March2025/mceclip10_48.png'
                    media='(max-width: 768px)'
                  />
                  <Image
                    src='https://mcdn.coolmate.me/image/March2025/mceclip7_84.png'
                    alt='Customer Base Expansion'
                    width={1000}
                    height={1000}
                    className='w-full'
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>

        {/* Third Slide - Distribution Channel Expansion */}
        <div className='outline-none'>
          <div className='grid grid-cols-12 gap-5'>
            <div className='col-span-12 md:col-span-5 md:flex md:flex-col md:justify-between'>
              <div className='text-heading-6 md:text-heading-4 2xl:text-heading-2 leading-tight text-white'>
                Mở rộng <br className='hidden md:block' /> kênh phân phối
              </div>
              <div className='mt-6 text-base text-white md:mt-10 md:text-2xl'>
                <div className='hidden items-center gap-3 md:flex'>
                  <div className='rounded-2xl border border-white px-6 py-3 text-lg text-white 2xl:text-2xl'>
                    D2C Online Only
                  </div>
                  <div>
                    <svg
                      width='29'
                      height='13'
                      viewBox='0 0 29 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M29 6.25L18.8985 0.655963L19.1047 12.2011L29 6.25ZM1.01785 7.74984L20.0193 7.41053L19.9836 5.41085L0.982146 5.75016L1.01785 7.74984Z'
                        fill='white'
                      />
                    </svg>
                  </div>
                  <div className='rounded-2xl border border-white px-6 py-3 text-lg text-white 2xl:text-2xl'>
                    Multi Channel
                  </div>
                </div>
                <div className='mt-4 md:mt-6'>
                  Online và trực tiếp vẫn là kênh phân phối chính hiện tại, tuy
                  nhiên sẽ bắt đầu tiếp cận thị trường Offline thông qua một số
                  hình thức phù hợp như: MT, GT, Pop-up Store, FlagShip Store.
                </div>
                <div className='mt-2 font-semibold md:mt-6'>
                  Doanh thu tới từ Offline sẽ chiếm {'>'}50% doanh số toàn công
                  ty vào năm 2030
                </div>
              </div>
            </div>
            <div className='col-span-12 md:col-span-7'>
              <Image
                src='https://mcdn.coolmate.me/image/March2025/mceclip1_100.png'
                alt='Distribution Channel Expansion'
                width={1000}
                height={1000}
                className='w-full object-cover'
              />
            </div>
          </div>
        </div>

        {/* Fourth Slide - Product Line Expansion */}
        <div className='outline-none'>
          <div className='grid grid-cols-12 gap-5'>
            <div className='col-span-12 md:col-span-5 md:flex md:flex-col md:justify-between'>
              <div className='text-heading-6 md:text-heading-4 2xl:text-heading-2 leading-tight text-white'>
                Mở rộng <br className='hidden md:block' /> ngành hàng
              </div>
              <div className='text-base text-white max-md:mt-6 md:text-2xl'>
                <div className='mt-4 md:mt-6'>
                  Phát triển nhóm sản phẩm giày, dép vào năm{' '}
                  <span className='font-semibold'>2026</span>
                </div>
                <div className='mt-2 font-semibold md:mt-6'>
                  Nhóm sản phẩm giày, dép sẽ chiếm hơn{' '}
                  <span className='font-semibold'>30%</span> doanh số của dòng
                  hàng thể thao vào năm{' '}
                  <span className='font-semibold'>2030</span>.
                </div>
              </div>
            </div>
            <div className='col-span-12 md:col-span-7'>
              <Image
                src='https://mcdn.coolmate.me/image/March2025/mceclip13_68.png'
                alt='Product Line Expansion'
                width={1000}
                height={1000}
                className='w-full object-cover'
              />
            </div>
          </div>
        </div>
      </div>

      <style jsx global>{`
        #bg-slider .slick-slide {
          padding: 0 20px;
        }

        @media (max-width: 768px) {
          #bg-slider {
            padding: 24px 20px !important;
          }
        }

        .pagination-dots {
          display: flex;
          justify-content: center;
          margin: 0;
          padding: 1rem 0;
          list-style-type: none;
        }

        .pagination-dots li {
          margin: 0 0.25rem;
        }

        .pagination-dots button {
          display: block;
          width: 0.5rem;
          height: 0.5rem;
          padding: 0;
          border: 2px solid #bbbbbb;
          border-radius: 100%;
          background-color: transparent;
          text-indent: -9999px;
        }

        .pagination-dots li.slick-active button {
          background-color: #333333;
          border: 2px solid #333333;
        }
      `}</style>
    </section>
  )
}
